import styled from "styled-components";

export const Wrap = styled.div`padding: 18px 22px 60px; font-family: Mulish; overflow-y: auto; height: 100%;`;
export const Empty = styled.div`padding: 60px 20px; text-align: center; color: #8A94A6; font-family: Mulish;`;
export const Card = styled.div`background: #FFF; border: 1px solid #EEF1F6; border-radius: 14px; padding: 18px 20px; margin-bottom: 16px;`;
export const HeaderCard = styled(Card)`display: flex; align-items: flex-start; gap: 18px;`;
export const Avatar = styled.div`
    flex: 0 0 auto; width: 66px; height: 66px; border-radius: 50%;
    background: ${(p) => p.$color || "#2F80ED"}; color: #FFF; font-weight: 800; font-size: 1.4rem;
    display: flex; align-items: center; justify-content: center;
`;
export const HInfo = styled.div`flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 4px;`;
export const Name = styled.div`display: flex; align-items: center; gap: 10px; font-size: 1.2rem; font-weight: 800; color: #2B3240;`;
export const Sub = styled.div`font-size: 0.84rem; color: #8A94A6; b { color: #2B3240; }`;
export const LinkRow = styled.div`
    display: flex; align-items: center; gap: 8px; margin-top: 6px; background: #F2F5FB; border-radius: 8px; padding: 8px 12px;
    a { color: #2F80ED; font-size: 0.8rem; text-decoration: none; word-break: break-all; }
`;
export const IconBtn = styled.button`border: none; background: transparent; color: #2F80ED; cursor: pointer; display: flex; font-size: 1rem;`;
export const KeyBtn = styled.button`
    margin-top: 8px; align-self: flex-start; border: 1px solid #CBD5E5; background: #FFFFFF; color: #2F80ED; cursor: pointer;
    border-radius: 8px; padding: 8px 13px; font-size: 0.85rem; font-weight: 700;
    display: inline-flex; align-items: center; gap: 7px; transition: background .15s, border-color .15s;
    svg { font-size: 1rem; }
    &:hover { background: #EEF4FF; border-color: #2F80ED; }
    &:disabled { opacity: 0.55; cursor: default; }
`;
export const KeyCard = styled.div`
    margin-top: 8px; align-self: flex-start; background: #F4F8FE; border: 1px solid #DCE6F7; border-radius: 8px; padding: 10px 12px;
`;
export const KeyValueRow = styled.div`display: flex; align-items: center; gap: 10px;`;
export const KeyLabel = styled.span`
    font-size: 0.7rem; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; color: #8A94A6;
`;
export const KeyValue = styled.span`
    font-family: "Courier New", monospace; font-size: 1.1rem; font-weight: 800; letter-spacing: 1.5px;
    color: #1F2A37; flex: 1; word-break: break-all;
`;
export const CopyBtn = styled.button`
    border: none; background: ${(p) => (p.$done ? "#22A559" : "#2F80ED")}; color: #FFF; cursor: pointer; border-radius: 7px;
    padding: 7px 12px; font-size: 0.8rem; font-weight: 700; display: inline-flex; align-items: center; gap: 6px; white-space: nowrap;
    transition: background .15s;
    &:hover { filter: brightness(0.96); }
`;
export const KeyNote = styled.div`
    font-size: 0.78rem; color: #9A6B12; margin-top: 8px; display: flex; align-items: flex-start; gap: 6px; line-height: 1.35;
    svg { flex: 0 0 auto; margin-top: 1px; }
`;
export const HActions = styled.div`flex: 0 0 auto; display: flex; gap: 10px;`;
export const MsgBtn = styled.a`
    display: inline-flex; align-items: center; gap: 6px; border: none; background: #384250; color: #FFF;
    font-family: Mulish; font-weight: 700; font-size: 0.8rem; padding: 9px 14px; border-radius: 8px; cursor: pointer; text-decoration: none;
`;
export const RemoveBtn = styled.button`
    display: inline-flex; align-items: center; gap: 6px; border: none; background: #EF4444; color: #FFF;
    font-family: Mulish; font-weight: 700; font-size: 0.8rem; padding: 9px 14px; border-radius: 8px; cursor: pointer;
`;
export const Badge = styled.span`
    background: ${(p) => (p.$role === "owner" ? "#FEF3C7" : "#EAF2FE")}; color: ${(p) => (p.$role === "owner" ? "#B45309" : "#2F80ED")};
    font-size: 0.72rem; font-weight: 800; padding: 3px 10px; border-radius: 10px;
`;
export const CardHead = styled.div`display: flex; align-items: center; justify-content: space-between; margin-bottom: 4px;`;
export const CardTitle = styled.h3`margin: 0; font-size: 1rem; font-weight: 800; color: #2B3240;`;
export const Hint = styled.p`margin: 4px 0 14px; font-size: 0.78rem; color: #8A94A6;`;
export const PresetBtn = styled.button`
    display: inline-flex; align-items: center; gap: 5px;
    border: none; background: transparent; color: #2F80ED; font-family: Mulish; font-weight: 700; font-size: 0.8rem; cursor: pointer;
    svg { font-size: 0.95rem; }
    &:disabled { opacity: 0.4; cursor: not-allowed; }
`;
export const RoleGrid = styled.div`display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px;`;
// Barra de Salvar/Cancelar — só aparece quando há rascunho não salvo (dirty).
// Footer normal no fim do conteúdo (sem position:sticky, que sobrepunha e quebrava ao rolar).
export const SaveBar = styled.div`
    margin-top: 18px;
    display: flex; align-items: center; justify-content: space-between; gap: 12px;
    background: #FFF; border-top: 1px solid #EEF1F6; padding: 12px 2px;
`;
export const SaveNote = styled.span`font-size: 0.8rem; color: #8A94A6; font-family: Mulish;`;
export const SaveActions = styled.div`display: flex; gap: 10px;`;
export const CancelChangesBtn = styled.button`
    border: 1px solid #CBD5E5; background: #FFF; color: #4B5563; font-family: Mulish; font-weight: 700;
    font-size: 0.82rem; padding: 8px 16px; border-radius: 8px; cursor: pointer;
    &:hover:not(:disabled) { background: #F2F5FB; }
    &:disabled { opacity: 0.5; cursor: not-allowed; }
`;
export const SaveChangesBtn = styled.button`
    border: none; background: #2F80ED; color: #FFF; font-family: Mulish; font-weight: 800;
    font-size: 0.82rem; padding: 8px 18px; border-radius: 8px; cursor: pointer;
    &:hover:not(:disabled) { background: #2567C4; }
    &:disabled { opacity: 0.5; cursor: not-allowed; }
`;
export const RoleCard = styled.button`
    text-align: left; border: 1.5px solid ${(p) => (p.$active ? "#2F80ED" : "#E3E8F0")};
    background: ${(p) => (p.$active ? "#F5F9FF" : "#FFF")}; border-radius: 12px; padding: 14px;
    cursor: ${(p) => (p.$disabled ? "not-allowed" : "pointer")};
    opacity: ${(p) => (p.$disabled && !p.$active ? 0.65 : 1)}; font-family: Mulish;
`;
// Cor do chip de papel (título do card de Role) — espelho do Figma: Owner laranja, Admin azul,
// Operator verde, Viewer cinza. Fundo em tom claro, texto/ícone na cor cheia.
const ROLE_COLORS = {
    owner: {fg: "#B45309", bg: "#FEF3C7"},
    admin: {fg: "#2F80ED", bg: "#EAF2FE"},
    operator: {fg: "#22A559", bg: "#E7F7EE"},
    viewer: {fg: "#6B7280", bg: "#F1F3F7"},
};
export const RoleName = styled.div`
    display: inline-flex; align-items: center; gap: 5px; margin-bottom: 8px;
    padding: 3px 9px; border-radius: 7px; font-weight: 800; font-size: 0.8rem; line-height: 1;
    color: ${(p) => (ROLE_COLORS[p.$role] || ROLE_COLORS.viewer).fg};
    background: ${(p) => (ROLE_COLORS[p.$role] || ROLE_COLORS.viewer).bg};
    svg { font-size: 0.95rem; }
`;
export const RoleDesc = styled.div`font-size: 0.74rem; color: #8A94A6; line-height: 1.35;`;
export const Group = styled.div`margin-top: 14px;`;
export const GroupTitle = styled.div`font-size: 0.82rem; font-weight: 800; color: #6B7280; margin-bottom: 4px;`;
export const Row = styled.div`display: flex; align-items: center; justify-content: space-between; gap: 16px; padding: 12px 0; border-bottom: 1px solid #F2F4F8;`;
export const RowInfo = styled.div`display: flex; flex-direction: column;`;
export const RowName = styled.span`font-size: 0.86rem; font-weight: 700; color: #2B3240;`;
export const OwnerOnly = styled.span`font-size: 0.7rem; font-weight: 700; color: #B45309; margin-top: 2px;`;
// Toggle movido para o componente compartilhado ../Toggle.
